export enum SchedulingMethod {
  UNIQUE = 'UNIQUE',

  RETROACTIVE = 'RETROACTIVE',
}
